export var TraceEvents;
(function (TraceEvents) {
    TraceEvents["Init"] = "start";
    TraceEvents["SessionCreated"] = "sessionCreated";
    TraceEvents["ConnectionCreated"] = "connectionCreated";
    TraceEvents["ConnectionDestroyed"] = "connectionDestroyed";
    TraceEvents["SessionDisconnected"] = "sessionDisconnected";
    TraceEvents["ParticipantAppeared"] = "participantAppeared";
    TraceEvents["ParticipantVideoAppeared"] = "participantVideoAppeared";
    TraceEvents["PnPersonLeft"] = "pnPersonLeft";
    TraceEvents["PnPersonJoin"] = "pnPersonJoin";
    TraceEvents["End"] = "end";
    TraceEvents["Restart"] = "restart";
})(TraceEvents || (TraceEvents = {}));
